import React, { Suspense } from 'react';
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Registration from '../pages/Registration/Registration';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import TutionFeeChalanForm from '../pages/Dashboard/Contents/ChalanForms/TutionFeeChalanForm';
import PrivateRoutes from './PrivateRoutes';

const NoMatchPage = () => {
    return (
        <Redirect to="/login" />
    );
};

const CheckLogin = () => {
    const uclToken = localStorage.getItem('uclToken');
    if (uclToken) {
        return (
            <Redirect to="/dashboard" />
        );
    } else {
        return (
            <Login />
        );
    }
}

const AppRoute = () => {

    return (
        <>
            <Router>
                <Suspense fallback={<p>Loading...</p>}>
                    <Switch>
                        <Route exact path="/login" component={CheckLogin} />
                        <Route exact path="/registration" component={Registration} />
                        <Route exact path="/forgot-password" component={ForgotPassword} />
                        <PrivateRoutes exact path="/dashboard/:value" component={Dashboard} />
                        <PrivateRoutes exact path="/dashboard" component={Dashboard} />
                        <PrivateRoutes exact path="/challan-view" component={TutionFeeChalanForm} />
                        <Route exact path="*" component={NoMatchPage} />
                    </Switch>
                </Suspense>
            </Router>
        </>
    );
}

export default AppRoute;
